export const GET_PRODUCT_CATEGORY_LISTING = "GET_PRODUCT_CATEGORY_LISTING";
export const GET_PRODUCT_CATEGORY_BY_ID = "GET_PRODUCT_CATEGORY_BY_ID";
export const SET_QUERY = "SET_QUERY";
